import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemporaryStrainer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30.0 30.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 15,
		cy: 15,
		rx: 15,
		ry: 15,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 24.0 3.0 L 0.0 15.0 L 24.0 27.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeDasharray: "2 2"
	})]
});
export default SvgTemporaryStrainer;
